import { createStore } from 'zustand'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { MemberBankListStore, MemberBankListStoreOptions } from './interface'

export const createMemberBankListStore = ({
  tableRef,
  member,
  memberType
}: MemberBankListStoreOptions) =>
  createStore<MemberBankListStore>((set, get) => ({
    tableRef,
    member,
    formMode: FormMode.CREATE,
    memberType,
    setFormMode: formMode => {
      set({ formMode })
    },
    currentAccountId: undefined,
    setCurrentAccountId: (accountId?: string) => {
      set({
        currentAccountId: accountId
      })
    },
    accountFormVisible: false,
    toggleAccountFormVisible: () => {
      const accountFormVisible = !get().accountFormVisible
      set({
        accountFormVisible
      })
      if (!accountFormVisible) {
        set({ currentAccountId: undefined })
      }
    }
  }))
